import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.member.list');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-member-list',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.member.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabMemberListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 24;
    public text: string = '';
    public org: any[] = [];
    public selectedNode: string = '';
    public loaded: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.search();
    }

    public async search(reset: boolean = true) {
        if (reset) this.page = 1;
        const res = await wiz.call("search", {
            page: this.page, dump: this.dump,
            text: this.text, node_id: this.selectedNode,
        });
        if (res.code === 200) {
            this.rows = res.data.rows || [];
            this.total = res.data.total || 0;
            this.org = res.data.org || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public selectNode(nid: string) {
        this.selectedNode = (this.selectedNode === nid) ? '' : nid;
        this.search();
    }

    public openProfile(u: any) {
        this.service.href(`/admin/collab/members/${u.id}`);
    }

    public presenceColor(p: string): string {
        const m: any = {
            online: 'bg-emerald-500', away: 'bg-amber-500',
            busy: 'bg-rose-500', offline: 'bg-zinc-300',
        };
        return m[p] || 'bg-zinc-300';
    }

    public presenceText(p: string): string {
        const m: any = {
            online: '온라인', away: '자리비움',
            busy: '바쁨', offline: '오프라인',
        };
        return m[p] || '오프라인';
    }
}

export default PortalLpsysadminCollabMemberListComponent;